/**
 * Disables input field zoom on iOS.
 */
export const disableIPhoneZoom = () => {
  // https://weblog.west-wind.com/posts/2023/Apr/17/Preventing-iOS-Safari-Textbox-Zooming
  if (navigator.userAgent.indexOf('iPhone') > -1) {
    const viewportMeta = document.querySelector('[name=viewport]');
    if (viewportMeta) {
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
    }
  }
};
